import React from 'react';
import { loadState, deleteState } from './localStorage';
import './thankYou.scss';

class StripeCallback extends React.Component {
  // After some amount of time, we should stop trying to resolve the order synchronously:
  MAX_POLL_COUNT = 10;
  pollCount = 0;
  submittedData = loadState('stripeIdeal');
  state = {
    title: null,
    content: null,
    source: this.submittedData ? this.submittedData.source : '',
    clientSecret: this.submittedData ? this.submittedData.clientSecret : '',
    planId: this.submittedData ? this.submittedData.planId : '',
    planName: this.submittedData ? this.submittedData.planName : '',
    site: this.submittedData ? this.submittedData.site : '',
  };

  componentDidMount() {
    const query = new URLSearchParams(window.location.search)
    this.pollForSourceStatus(query.get('source'), query.get('client_secret'));
  };

  pollForSourceStatus = (sourceId, clientSecret) => {
    let key = window.settings.paymentProviders && window.settings.paymentProviders.stripe && window.settings.paymentProviders.stripe.apiKey
    if(key) {
      let stripe = window.Stripe(key);
      stripe.retrieveSource({ id: sourceId, client_secret: clientSecret }).then((result) => {
        let source = result.source;
        if (source.status === 'chargeable') {
          // Make a request to your server to charge the Source.
          // Depending on the Charge status, show your customer the relevant message.
          console.log('Make a request to your server to charge the Source. Depending on the Charge status, show your customer the relevant message.')
          this.setState({ content: this.sourceStatus(source.status) });
        } else if (source.status === 'pending' && this.pollCount < this.MAX_POLL_COUNT) {
          // Try again in a second, if the Source is still `pending`:
          this.pollCount += 1;
          setTimeout(this.pollForSourceStatus, 1000);
        } else {
          console.log('Depending on the Source status, show your customer the relevant message');
          console.log(source);
          const respCont = source.redirect.failure_reason ? `${this.sourceStatus(source.redirect.status)}. ${source.redirect.failure_reason}` : `${this.sourceStatus((source.redirect.status))}`
          deleteState('stripeIdeal');
          this.setState({ content: respCont })
        }
      });
    }   
  }


  sourceStatus = (status) => {
    switch (status) {
      case 'chargeable':
        return this.props.fields.iDealChargeableMessage || 'Your order was received and is awaiting payment confirmation.';
      case 'canceled':
      case 'failed':
        return this.props.fields.iDealFailedMessage || 'Your payment failed and your order couldn’t be processed.';
      case 'pending':
        return this.props.fields.iDealPendingMessage || 'Your order was received and is awaiting payment confirmation.';
      case 'succeeded':
        return this.props.fields.iDealSucceededMessage || 'Your payment is confirmed and your order is complete.';
      default:
        return this.props.fields.iDealDefaultMessage || 'We cannot find the status of your order';
    }
  }

  render() {
    return ( <div className="iDeal-wrapper">
      <div className="modal-dialog" >
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">{this.props.fields.iDealPurchaseStatusLabel || "Purchase status"}</div>
          <div className="modal-body">{this.state.content}</div>
        </div>
      </div>
    </div>);
  }
}

export default StripeCallback;